import {
  Person,
  Share,
  Favorite,
  Paid,
  ContentCopy,
  StarPurple500,
} from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HotelIcon from "@mui/icons-material/Hotel";
import { Avatar, Select, MenuItem } from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import PasswordInput from "../../components/passwordbox";
import { useDispatch } from "react-redux";
import { updateUserProfile } from "../../redux/slices/auth";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { logout } from "../../redux/slices/auth";
import Subscriptions from "./Subscriptions";
import { useNavigate } from "react-router-dom";
import TextBox from "../../components/textbox";
import PasswordIcon from "@mui/icons-material/Password";
import CustomDropdown from "../../components/NewDropDown/sortingDropdown";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CopyIcon from "../../components/CopyIcon";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SaveIcon from "@mui/icons-material/Save";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SwaggerUI from "swagger-ui-react";
import { v4 as uuidv4 } from "uuid";
import "swagger-ui-react/swagger-ui.css";
const UserProfile = () => {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(1);
  const [profileImage, setProfileImage] = useState();
  const [profileImageUrl, setProfileImageUrl] = useState();
  const [travellerData, setTravellerData] = useState({
    name: "",
    middleName: "",
    lastName: "",
    gender: "",
    city: "",
    dateOfBirth: "",
    email: "",
    affiliateDetails: "",
    referredCorporateId: "",
    role: "",
  });
  const [affiliateCustomerData, setAffiliateCustomerData] = useState({
    overallLifetimeTotalBookings: "",
    overallLifetimeTotalSale: "",
    overallLifetimeCommission: "",
    overallLifetimeCommissionReceived: "",
    overallLifetimeCommissionPending: "",
    overallCurrentMonthTotalSale: "",
    overallCurrentMonthCommission: "",
    overallCurrentMonthTotalBookings: "",
    numberOfAffiliates: "",
    numberOfActiveAffiliatesLifetime: "",
    numberOfActiveAffiliatesCurrentMonth: "",
  });
  const [bAffiliateCustomerData, setBAffiliateCustomerData] = useState({
    overallLifetimeTotalBookings: "",
    overallLifetimeCommissionReceived: "",
    overallLifetimeCommissionPending: "",
  });
  const [corporateCustomersData, setCorporateCustomersData] = useState({
    numberOfCorporateAgents: "",
    corporateAgents: "",
  });
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);
  const [swaggerSpec, setSwaggerSpec] = useState(null);
  const [apiKey, setApiKey] = useState("");
  const naviagte = useNavigate();
  const paragraphRef = useRef(null);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND + "auth/getuserdetails")
      .then((resp) => {
        console.log("UserData  --> " + JSON.stringify(resp));

        setTravellerData({
          name: resp.data.data.name,
          middleName:
            resp.data.data.middleName !== "null" &&
            resp.data.data.middleName !== "undefined" &&
            resp.data.data.middleName !== " " &&
            resp.data.data.middleName !== null &&
            resp.data.data.middleName !== undefined
              ? resp.data.data.middleName
              : "",
          lastName:
            resp.data.data.lastName !== "null" &&
            resp.data.data.lastName !== "undefined" &&
            resp.data.data.lastName !== " " &&
            resp.data.data.lastName !== null &&
            resp.data.data.lastName !== undefined
              ? resp.data.data.lastName
              : "",
          gender: resp.data.data.gender,
          city:
            resp.data.data.city !== "null" &&
            resp.data.data.city !== "undefined" &&
            resp.data.data.city !== " " &&
            resp.data.data.city !== null &&
            resp.data.data.city !== undefined
              ? resp.data.data.city
              : "",
          dateOfBirth: resp.data.data.dob,
          email: resp.data.data.mail,
          affiliateDetails: resp.data.data.affiliateDetails,
          referredCorporateId: resp.data.data.referredCorporateId,
          role: resp.data.data.role,
        });
        setProfileImageUrl(resp.data.data.picture);
      });
    getAffiliateCustomersData();
    getBAffiliateCustomersData();
    getCorporateCustomersData();
  }, []);
  useEffect(() => {
    if (tabValue === 6) {
      axios
        .get(process.env.REACT_APP_BACKEND_ZENTRUM + "docs")
        .then((resp) => {
          setSwaggerSpec(resp.data);
        })
        .catch((err) => {
          toast.error("Failed to load API documentation");
        });
    }
  }, [tabValue]);
  const handleChangeTab = (id) => {
    setTabValue(id);
  };
  const handleGenerateApiKey = () => {
    const newApiKey = uuidv4();
    setApiKey(newApiKey);
    toast.success("Generated new key!");
  };
  const handleSave = () => {
    if (apiKey) {
      axios
        .post(process.env.REACT_APP_BACKEND + "auth/keyupdate", {
          apiKey,
        })
        .then((resp) => {
          toast.success(resp.data.message);
        })
        .catch((err) => toast.error("Failed to update API Key"));
    }
  };
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      toast.success("Copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy to clipboard");
    }
  };
  const getAffiliateCustomersData = () => {
    axios
      .get(process.env.REACT_APP_BACKEND + "auth/getAffiliateCustomersData")
      .then((resp) => {
        if (resp.data.data?.numberOfAffiliates) {
          setAffiliateCustomerData({
            overallLifetimeTotalBookings:
              resp.data.data.overallLifetimeTotalBookings,
            overallLifetimeTotalSale: resp.data.data.overallLifetimeTotalSale,
            overallLifetimeCommissionReceived:
              resp.data.data.overallLifetimeCommissionReceived,
            overallLifetimeCommissionPending:
              resp.data.data.overallLifetimeCommissionPending,
            overallCurrentMonthTotalSale:
              resp.data.data.overallCurrentMonthTotalSale,
            overallCurrentMonthCommission:
              resp.data.data.overallCurrentMonthCommission,
            overallCurrentMonthTotalBookings:
              resp.data.data.overallCurrentMonthTotalBookings,
            numberOfAffiliates: resp.data.data.numberOfAffiliates,
            numberOfActiveAffiliatesLifetime:
              resp.data.data.numberOfActiveAffiliatesLifetime,
            numberOfActiveAffiliatesCurrentMonth:
              resp.data.data.numberOfActiveAffiliatesCurrentMonth,
            //affiliates: resp.data.data.affiliates, enable this later on if needed
          });
        }
      });
  };
  const getBAffiliateCustomersData = () => {
    axios
      .get(process.env.REACT_APP_BACKEND + "auth/getBAffiliateCustomersData")
      .then((resp) => {
        if (resp.data?.data) {
          setBAffiliateCustomerData({
            overallLifetimeTotalBookings:
              resp.data.data.overallLifetimeTotalBookings,
            overallLifetimeCommissionReceived:
              resp.data.data.overallLifetimeCommissionReceived,
            overallLifetimeCommissionPending:
              resp.data.data.overallLifetimeCommissionPending,
          });
        }
      });
  };

  const getCorporateCustomersData = () => {
    axios
      .get(process.env.REACT_APP_BACKEND + "auth/getCorporateCustomersData")
      .then((resp) => {
        console.log("getCorporateCustomersData  --> " + JSON.stringify(resp));
        if (resp.data.data?.corporateAgents) {
          setCorporateCustomersData({
            corporateAgents: resp.data.data.corporateAgents,
            numberOfCorporateAgents: resp.data.data.numberOfCorporateAgents,
          });
        }
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    console.log(today, value);
    if (name === "dateOfBirth" && value > today) {
      setError("Invalid Date of Birth.");
      return;
    }
    setTravellerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      setProfileImageUrl(URL.createObjectURL(file));
      const formData = new FormData();
      formData.append("picture", file);
      axios
        .post(process.env.REACT_APP_BACKEND + "auth/userupdate", formData)
        .then((resp) => {
          setTravellerData({
            name: resp.data.data.name,
            middleName: resp.data.data.middleName,
            lastName: resp.data.data.lastName,
            gender: resp.data.data.gender,
            city: resp.data.data.city,
            dateOfBirth: resp.data.data.dob,
            email: resp.data.data.mail,
            affiliateDetails: resp.data.data.affiliateDetails,
            referredCorporateId: resp.data.data.referredCorporateId,
            role: resp.data.data.role,
          });
          setProfileImageUrl(resp.data.data.picture);
          toast.success(resp.data.message);
          dispatch(
            updateUserProfile({
              name: resp.data.data.name,
              picture: resp.data.data.picture,
            })
          );
        });
    }
  };

  const handleSubmitTravellerInfo = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", travellerData.name);
    formData.append("middleName", travellerData.middleName);
    formData.append("lastName", travellerData.lastName);
    formData.append("gender", travellerData.gender);
    formData.append("dob", travellerData.dateOfBirth);
    formData.append("city", travellerData.city);
    formData.append(
      "affiliateDetails",
      JSON.stringify({
        affiliateLink:
          "https://www.sevenlytravel.com/" + travellerData.affiliateLink,
      })
    );
    if (profileImage) {
      formData.append("picture", profileImage);
    }
    axios
      .post(process.env.REACT_APP_BACKEND + "auth/userupdate", formData)
      .then((resp) => {
        setTravellerData({
          name: resp.data.data.name,
          middleName:
            resp.data.data.middleName !== "undefined"
              ? resp.data.data.middleName
              : "",
          lastName:
            resp.data.data.lastName != "undefined"
              ? resp.data.data.lastName
              : "",
          gender: resp.data.data.gender,
          city: resp.data.data.city !== "undefined" ? resp.data.data.city : "",
          dateOfBirth: resp.data.data.dob,
          email: resp.data.data.mail,
          affiliateDetails: resp.data.data.affiliateDetails,
          referredCorporateId: resp.data.data.referredCorporateId,
          role: resp.data.data.role,
        });
        setProfileImageUrl(resp.data.data.picture);
        toast.success(resp.data.message);
        dispatch(
          updateUserProfile({
            name: resp.data.data.name,
            picture: resp.data.data.picture,
          })
        );
      });
  };
  const handleChangePassword = () => {
    axios
      .post(process.env.REACT_APP_BACKEND + "auth/resetpassword", {
        newPassword: newPassword,
        confirmPassword: confirmPassword,
        oldPass: currentPassword,
      })
      .then((resp) => {
        toast.success(resp.data.message);
        setNewPassword("");
        setConfirmPassword("");
        setCurrentPassword("");
        handleLogout();
      })
      .catch((err) => toast.error(err.response.data.message));
  };
  const handleLogout = () => {
    dispatch(logout());
    naviagte("/login");
  };
  return (
    <div className="bgsearch">
      <div className="container py-5 ">
        {/* <div className="d-flex py-5">
          <div className="d-flex align-items-center justify-content-center flex-column">
            <Avatar
              src={profileImageUrl}
              alt={travellerData.name}
              style={{ width: "80px", height: "80px" }}
            />
            <div className="mt-4">
              <input
                type="file"
                id="upload"
                hidden
                onChange={handleImageChange}
              />
              <label for="upload" className="btn-contained">
                Upload
              </label>
            </div>
          </div>

          <div className="ms-3">
            <h1>{travellerData?.name}</h1>
            <p className="fs-8">{travellerData?.email}</p>
          </div>
        </div> */}
        <div className="row">
          <div className="col-lg-3 mb-4">
            <div
              className="bxShadow "
              style={{ borderRadius: "12px", background: "var(--white-color)" }}
            >
              <div
                className="t-center py-4"
                style={{ borderBottom: "1px solid var(--grey-color)" }}
              >
                <div style={{ position: "relative", display: "inline-block" }}>
                  {/* Avatar */}
                  <Avatar
                    src={profileImageUrl}
                    alt={travellerData.name}
                    style={{ width: "120px", height: "120px" }}
                    className="bxShadow"
                  />

                  {/* Edit Icon */}
                  <label
                    htmlFor="upload"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      width: "26px",
                      height: "26px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    ✎
                  </label>
                  <input
                    type="file"
                    id="upload"
                    hidden
                    onChange={handleImageChange}
                  />
                </div>
                <div className="ms-3">
                  <h1>{travellerData?.name}</h1>
                  <p className="fs-8">{travellerData?.email}</p>
                </div>
              </div>
              <div
                className={`d-flex align-items-center p-3 c-pointer ${
                  tabValue === 1 ? "practive-Tab" : ""
                }`}
                onClick={() => handleChangeTab(1)}
              >
                <Person />
                <p className="ms-2">Profile Info</p>
              </div>
              <div
                className={`d-flex align-items-center p-3 c-pointer ${
                  tabValue === 2 ? "practive-Tab" : ""
                }`}
                onClick={() => handleChangeTab(2)}
              >
                <MonetizationOnIcon />
                <p className="ms-2">Subscriptions</p>
              </div>
              <div
                className={`d-flex align-items-center p-3 c-pointer ${
                  tabValue === 3 ? "practive-Tab" : ""
                }`}
                onClick={() => handleChangeTab(3)}
              >
                <PasswordIcon />
                <p className="ms-2">Change Password</p>
              </div>
              {travellerData?.role !== "affiliate" &&
              travellerData.affiliateDetails &&
              travellerData.affiliateDetails.affiliateType ? (
                <div
                  className={`d-flex align-items-center p-3 c-pointer ${
                    tabValue === 2 ? "practive-Tab" : ""
                  }`}
                  onClick={() => handleChangeTab(4)}
                >
                  <Share />
                  <p className="ms-2">Affiliate Profile</p>
                </div>
              ) : (
                ""
              )}

              {travellerData?.role === "corporate" &&
              !travellerData?.referredCorporateId ? (
                <div
                  className={`d-flex align-items-center p-3 c-pointer ${
                    tabValue === 2 ? "practive-Tab" : ""
                  }`}
                  onClick={() => handleChangeTab(5)}
                >
                  <Share />
                  <p className="ms-2">Corporate Profile</p>
                </div>
              ) : (
                ""
              )}
              {travellerData?.role === "affiliate" ? (
                <div
                  className={`d-flex align-items-center p-3 c-pointer ${
                    tabValue === 6 ? "practive-Tab" : ""
                  }`}
                  onClick={() => handleChangeTab(6)}
                >
                  <Share />
                  <p className="ms-2">Affiliate Profile</p>
                </div>
              ) : (
                ""
              )}

              {/* <div
                className={`d-flex align-items-center p-3 c-pointer ${
                  tabValue === 4 ? "practive-Tab" : ""
                }`}
                onClick={() => handleChangeTab(3)}
              >
                <PasswordIcon />
                <p className="ms-2">User Pins</p>
              </div> */}
            </div>
          </div>
          <div className="col-lg-9">
            {tabValue == 1 && (
              <div
                className="bxShadow p-3"
                style={{
                  borderRadius: "12px",
                  background: "var(--white-color)",
                }}
              >
                <h2>Profile Information</h2>
                <hr className="my-3" />
                <div className="my-3 d-flex  align-items-center justify-content-between flex-wrap">
                  <TextBox
                    maincontStyle={{ width: "32%" }}
                    label="First Name"
                    name="name"
                    value={travellerData?.name}
                    onChange={handleChange}
                    maxLength="50"
                  />
                  <TextBox
                    fullWidth={true}
                    maincontStyle={{ width: "32%" }}
                    label="Middle Name"
                    name="middleName"
                    value={travellerData?.middleName}
                    onChange={handleChange}
                    maxLength="50"
                  />

                  <TextBox
                    fullWidth={true}
                    maincontStyle={{ width: "32%" }}
                    label="Last Name"
                    name="lastName"
                    value={travellerData?.lastName}
                    onChange={handleChange}
                    maxLength="50"
                  />
                </div>
                <div className="row">
                  <div className="col-md-6 mb-1">
                    {/* <div className="mt-1">
                      <p className="fs-8 mb-2">Gender</p>
                      <Select
                        fullWidth
                        name="gender"
                        value={travellerData?.gender}
                        onChange={handleChange}
                        style={{ borderRadius: "8px", height: "2.8rem" }}
                      >
                        <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem>
                        <MenuItem value="binary">Binary</MenuItem>
                      </Select>
                    </div> */}
                    <div className="mt-1">
                      <p className="fs-8 mb-2">Gender</p>
                      <CustomDropdown
                        value={travellerData?.gender}
                        onChange={(value) =>
                          setTravellerData((prevData) => ({
                            ...prevData,
                            gender: value,
                          }))
                        }
                        options={genderOptions}
                        placeholder="Select"
                        props={{
                          borderRadius: "8px",
                          width: "95%",
                          height: "32px",
                        }}
                        width="90%"
                      />
                    </div>
                    <div className="my-3">
                      <TextBox
                        label="City"
                        fullWidth
                        name="city"
                        value={travellerData.city}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <TextBox
                        fullWidth
                        label="Date of Birth"
                        type="date"
                        name="dateOfBirth"
                        value={travellerData?.dateOfBirth}
                        onChange={handleChange}
                      />

                      <p className="fs-8" style={{ color: "var(--red-color)" }}>
                        {error}
                      </p>
                    </div>
                    {/* <div className="my-3">
                      <p className="fs-8 mb-1">Email</p>
                      <TextField fullWidth type="Email" />
                    </div> */}
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    className="btn-contained"
                    onClick={handleSubmitTravellerInfo}
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
            {tabValue == 2 && <Subscriptions />}
            {tabValue == 3 && (
              <div
                className="bxShadow p-3"
                style={{
                  borderRadius: "12px",
                  background: "var(--white-color)",
                }}
              >
                <h2>Password</h2>
                <hr className="my-3" />
                <div className="row">
                  <div className="col-lg-4 mb-1">
                    <div className="my-3">
                      <p className="fs-8 mb-1">Current Password</p>
                      <PasswordInput
                        placeholder="current password"
                        value={currentPassword}
                        onPasswordChange={(value) => setCurrentPassword(value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="my-3">
                      <p className="fs-8 mb-1">New Password</p>

                      <PasswordInput
                        placeholder="New password"
                        value={newPassword}
                        onPasswordChange={(value) => setNewPassword(value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="my-3">
                      <p className="fs-8 mb-1">Re-Type Password</p>
                      <PasswordInput
                        placeholder="Re-Type password"
                        value={confirmPassword}
                        onPasswordChange={(value) => setConfirmPassword(value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    className="btn-contained"
                    onClick={handleChangePassword}
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
            {tabValue == 4 && (
              <div
                className="bxShadow p-3"
                style={{
                  borderRadius: "12px",
                  background: "var(--white-color)",
                }}
              >
                <h2>Affiliate Profile</h2>
                <hr className="my-3" />
                <div className="my-3">
                  <p>
                    Thank you for being a{" "}
                    <span
                      className="view-style fs-16 fw-900"
                      style={{ color: "#3dd2cc" }}
                    >
                      Sevenly <i>Star</i>
                    </span>{" "}
                    affiliate
                    <Favorite style={{ cursor: "pointer", color: "red" }} />
                  </p>
                </div>
                <h3>Affiliate link:</h3>
                <div className="my-3 d-flex  align-items-center flex-wrap">
                  <i>
                    <p style={{ marginRight: "10px" }}>
                      https://www.sevenlytravel.com/signup/
                      {travellerData.affiliateDetails.affiliateLink}
                    </p>
                  </i>
                  <CopyIcon
                    text={
                      "https://www.sevenlytravel.com/signup/" +
                      travellerData.affiliateDetails.affiliateLink
                    }
                  />
                </div>
                <h3>Lifetime Metrics:</h3>
                <hr className="my-3" />
                <div style={{ display: "flex" }}>
                  <div className="flex w30" style={{ margin: "0 10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>Registered Users</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            {affiliateCustomerData.numberOfAffiliates &&
                            !isNaN(+affiliateCustomerData.numberOfAffiliates)
                              ? +affiliateCustomerData.numberOfAffiliates
                              : "0"}
                          </h2>
                          <AccountCircleIcon
                            style={{
                              alignItems: "left",
                              fontSize: "60px",
                              color: "#3dd2cc",
                            }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                  <div className="flex w30" style={{ margin: "0 10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>
                            Users With Bookings
                          </p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            {affiliateCustomerData.numberOfActiveAffiliatesLifetime &&
                            !isNaN(
                              +affiliateCustomerData.numberOfActiveAffiliatesLifetime
                            )
                              ? +affiliateCustomerData.numberOfActiveAffiliatesLifetime
                              : "0"}
                          </h2>
                          <AccountCircleIcon
                            style={{
                              alignItems: "left",
                              fontSize: "60px",
                              color: "#3dd2cc",
                            }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                  <div className="flex w30" style={{ margin: "0 10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>Hotel Bookings</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            {affiliateCustomerData.overallLifetimeTotalBookings &&
                            !isNaN(
                              +affiliateCustomerData.overallLifetimeTotalBookings
                            )
                              ? +affiliateCustomerData.overallLifetimeTotalBookings
                              : "0"}
                          </h2>
                          <HotelIcon
                            style={{ fontSize: "60px", color: "#9966ff" }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div className="flex w30" style={{ margin: "10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>Commision Received</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            $
                            {affiliateCustomerData.overallLifetimeCommissionReceived &&
                            !isNaN(
                              +affiliateCustomerData.overallLifetimeCommissionReceived
                            )
                              ? (+affiliateCustomerData.overallLifetimeCommissionReceived).toFixed(
                                  2
                                )
                              : "0.00"}
                          </h2>
                          <Paid
                            style={{ fontSize: "60px", color: "#9966ff" }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                  <div className="flex w30" style={{ margin: "10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>Commision Pending</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            $
                            {affiliateCustomerData.overallLifetimeCommissionPending &&
                            !isNaN(
                              +affiliateCustomerData.overallLifetimeCommissionPending
                            )
                              ? (+affiliateCustomerData.overallLifetimeCommissionPending).toFixed(
                                  2
                                )
                              : "0.00"}
                          </h2>
                          <Paid
                            style={{ fontSize: "60px", color: "#9966ff" }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </div>
                {affiliateCustomerData.numberOfActiveAffiliatesCurrentMonth >
                0 ? (
                  <div>
                    <div style={{ margin: "20px" }} />
                    <h3>Current Month Metrics:</h3>
                    <hr className="my-3" />

                    <div style={{ display: "flex" }}>
                      <div className="flex w30" style={{ margin: "0 10px" }}>
                        <Card className="border_radius ">
                          <CardContent>
                            <div className="d-flex justify-content-between">
                              <p style={{ fontSize: "15px" }}>
                                Registered Users
                              </p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <h2
                                className="success"
                                style={{
                                  alignItems: "right",
                                  fontSize: "30px",
                                }}
                              >
                                {affiliateCustomerData.numberOfActiveAffiliatesCurrentMonth &&
                                !isNaN(
                                  +affiliateCustomerData.numberOfActiveAffiliatesCurrentMonth
                                )
                                  ? +affiliateCustomerData.numberOfActiveAffiliatesCurrentMonth
                                  : "0"}
                              </h2>
                              <AccountCircleIcon
                                style={{
                                  alignItems: "left",
                                  fontSize: "60px",
                                  color: "#3dd2cc",
                                }}
                              />
                            </div>
                          </CardContent>
                        </Card>
                      </div>
                      <div className="flex w30" style={{ margin: "0 10px" }}>
                        <Card className="border_radius ">
                          <CardContent>
                            <div className="d-flex justify-content-between">
                              <p style={{ fontSize: "15px" }}>Hotel Bookings</p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <h2
                                className="success"
                                style={{
                                  alignItems: "right",
                                  fontSize: "30px",
                                }}
                              >
                                {affiliateCustomerData.overallCurrentMonthTotalBookings &&
                                !isNaN(
                                  +affiliateCustomerData.overallCurrentMonthTotalBookings
                                )
                                  ? +affiliateCustomerData.overallCurrentMonthTotalBookings
                                  : "0"}
                              </h2>
                              <HotelIcon
                                style={{ fontSize: "60px", color: "#9966ff" }}
                              />
                            </div>
                          </CardContent>
                        </Card>
                      </div>
                      <div className="flex w30" style={{ margin: "0 10px" }}>
                        <Card className="border_radius ">
                          <CardContent>
                            <div className="d-flex justify-content-between">
                              <p style={{ fontSize: "15px" }}>
                                Commision Earned
                              </p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <h2
                                className="success"
                                style={{
                                  alignItems: "right",
                                  fontSize: "30px",
                                }}
                              >
                                $
                                {affiliateCustomerData.overallCurrentMonthCommission &&
                                !isNaN(
                                  +affiliateCustomerData.overallCurrentMonthCommission
                                )
                                  ? (+affiliateCustomerData.overallCurrentMonthCommission).toFixed(
                                      2
                                    )
                                  : "0.00"}
                              </h2>
                              <Paid
                                style={{ fontSize: "60px", color: "#9966ff" }}
                              />
                            </div>
                          </CardContent>
                        </Card>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <hr className="my-3" />
                    <p>
                      <i>
                        Bring in your friends and family to our{" "}
                        <span
                          className="view-style fs-15 fw-900"
                          style={{ color: "#3dd2cc" }}
                        >
                          Sevenly world{" "}
                        </span>
                        via your Affiliate link to{" "}
                        <b>
                          <i>EARN COMMISSION</i>
                        </b>{" "}
                        on each booking they made !
                      </i>
                    </p>
                  </div>
                )}
              </div>
            )}
            {tabValue == 5 && (
              <div
                className="bxShadow p-3"
                style={{
                  borderRadius: "12px",
                  background: "var(--white-color)",
                }}
              >
                <h2>Corporate Profile</h2>
                <hr className="my-3" />
                <div className="my-3">
                  <p>
                    Thank you for being a{" "}
                    <span
                      className="view-style fs-16 fw-900"
                      style={{ color: "#3dd2cc" }}
                    >
                      Sevenly's <i>Corporate</i>
                    </span>{" "}
                    member
                    <Favorite style={{ cursor: "pointer", color: "red" }} />
                  </p>
                </div>

                {!travellerData?.referredCorporateId ||
                travellerData.referredCorporateId.trim == "" ? (
                  <div className="mt-2">
                    <h2 className="mb-3">Registered Agents</h2>
                    <hr className="my-3" />
                    {corporateCustomersData?.corporateAgents?.length > 0 ? (
                      <div className="d-flex flex-wrap">
                        {corporateCustomersData.corporateAgents.map((agent) => {
                          const agentId =
                            agent.userId?.$oid || agent.userId || "unknown";

                          return (
                            <div
                              className="flex w60"
                              style={{ margin: "0 10px 20px 10px" }}
                              key={agentId}
                            >
                              <Card className="border_radius">
                                <CardContent>
                                  <div className="d-flex justify-content-between mb-2">
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {agent.name || "N/A"}
                                    </p>
                                    <span
                                      className="text-muted"
                                      style={{ fontSize: "18px" }}
                                    >
                                      {agent.city}
                                    </span>
                                    <AccountCircleIcon
                                      style={{
                                        alignItems: "left",
                                        fontSize: "60px",
                                        color: "#3dd2cc",
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{ fontSize: "18px", color: "#555" }}
                                  >
                                    <div>
                                      <strong>Email:</strong>{" "}
                                      {agent.email || "N/A"}
                                    </div>
                                    <div>
                                      <strong>Total Bookings:</strong>{" "}
                                      {agent.totalBookings}
                                    </div>
                                    <div>
                                      <strong>Total Sale:</strong> $
                                      {agent.totalSaleAmount.toFixed(2)}
                                    </div>
                                  </div>
                                </CardContent>
                              </Card>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="text-muted">No Agents.</p>
                    )}
                  </div>
                ) : (
                  <div className="mt-2">
                    <p className="text-muted">
                      Please contact your corporate account owner!
                    </p>
                  </div>
                )}
              </div>
            )}
            {tabValue == 6 && (
              <div
                className="bxShadow p-3"
                style={{
                  borderRadius: "12px",
                  background: "var(--white-color)",
                }}
              >
                <h2>Affiliate Profile</h2>
                <hr className="my-3" />
                <div className="my-3">
                  <p>
                    Thank you for being an affiliate
                    <Favorite style={{ cursor: "pointer", color: "red" }} />
                  </p>
                </div>
                <h3>Api Key:</h3>
                <div className="my-3">
                  <p>
                    Please make sure you copy the key generated before/after
                    saving.
                  </p>
                </div>
                <div className="my-3 d-flex  align-items-center flex-wrap">
                  <Paper
                    component="form"
                    sx={{
                      p: "2px 4px",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      placeholder="API key"
                      inputProps={{ "aria-label": "API key" }}
                      value={apiKey}
                      onChange={(e) => setApiKey(e.target.value)}
                    />
                    <IconButton
                      type="button"
                      sx={{ p: "10px" }}
                      aria-label="Generate"
                      onClick={handleGenerateApiKey}
                    >
                      <AutorenewIcon />
                    </IconButton>
                    <Divider
                      sx={{ height: 28, m: 0.5 }}
                      orientation="vertical"
                    />
                    <IconButton
                      color="primary"
                      sx={{ p: "10px" }}
                      onClick={handleCopy}
                      aria-label="Copy to clipboard"
                    >
                      <ContentCopyIcon />
                    </IconButton>
                    <Divider
                      sx={{ height: 28, m: 0.5 }}
                      orientation="vertical"
                    />
                    <IconButton
                      color="primary"
                      sx={{ p: "10px" }}
                      aria-label="Save"
                      onClick={handleSave}
                    >
                      <SaveIcon />
                    </IconButton>
                  </Paper>
                </div>
                <h3>Lifetime Metrics:</h3>
                <hr className="my-3" />
                <div style={{ display: "flex" }}>
                  <div className="flex w30" style={{ margin: "0 10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>Hotel Bookings</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            {bAffiliateCustomerData.overallLifetimeTotalBookings &&
                            !isNaN(
                              +bAffiliateCustomerData.overallLifetimeTotalBookings
                            )
                              ? +bAffiliateCustomerData.overallLifetimeTotalBookings
                              : "0"}
                          </h2>
                          <HotelIcon
                            style={{ fontSize: "60px", color: "#9966ff" }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div className="flex w30" style={{ margin: "10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>Commision Received</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            $
                            {bAffiliateCustomerData.overallLifetimeCommissionReceived &&
                            !isNaN(
                              +bAffiliateCustomerData.overallLifetimeCommissionReceived
                            )
                              ? (+bAffiliateCustomerData.overallLifetimeCommissionReceived).toFixed(
                                  2
                                )
                              : "0.00"}
                          </h2>
                          <Paid
                            style={{ fontSize: "60px", color: "#9966ff" }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                  <div className="flex w30" style={{ margin: "10px" }}>
                    <Card className="border_radius ">
                      <CardContent>
                        <div className="d-flex justify-content-between">
                          <p style={{ fontSize: "15px" }}>Commision Pending</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <h2
                            className="success"
                            style={{ alignItems: "right", fontSize: "30px" }}
                          >
                            $
                            {bAffiliateCustomerData.overallLifetimeCommissionPending &&
                            !isNaN(
                              +bAffiliateCustomerData.overallLifetimeCommissionPending
                            )
                              ? (+bAffiliateCustomerData.overallLifetimeCommissionPending).toFixed(
                                  2
                                )
                              : "0.00"}
                          </h2>
                          <Paid
                            style={{ fontSize: "60px", color: "#9966ff" }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </div>
                <div>
                  <hr className="my-3" />
                  <p>
                    <i>
                      Integrate our Hotel Booking API into your platform and
                      start{" "}
                      <b>
                        <i>EARNING COMMISSIONS</i>
                      </b>{" "}
                      on every booking you generate — power your business with{" "}
                      <span
                        className="view-style fs-15 fw-900"
                        style={{ color: "#3dd2cc" }}
                      >
                        Sevenly
                      </span>{" "}
                      and turn every stay into a payday!
                    </i>
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12">
            <br />
            {tabValue == 6 && (
              <div
                className="bxShadow p-3 swaggerbox"
                style={{
                  borderRadius: "12px",
                  background: "var(--white-color)",
                }}
              >
                {swaggerSpec ? (
                  <SwaggerUI spec={swaggerSpec} />
                ) : (
                  <p>Loading API documentation...</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;

const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "others", label: "Others" },
];
